import styled from 'styled-components';
import { px2rem } from '../../utils/helpers/style.js';
import { spacing } from '../../constants/spacing.js';
import { styles } from '../../constants/styles.js';
import { fontFamilyStyles } from '../../ContentText/styles.web.js';

var wrapper = /*#__PURE__*/styled.ul.withConfig({
  displayName: "styles__wrapper",
  componentId: "sc-3v10ji-0"
})(["display:flex;align-items:center;padding-left:0;flex:1;height:", ";"], px2rem(80));
var item = /*#__PURE__*/styled.li.withConfig({
  displayName: "styles__item",
  componentId: "sc-3v10ji-1"
})(["list-style:none;margin-right:", ";"], spacing.s);
var link = /*#__PURE__*/styled.a.withConfig({
  displayName: "styles__link",
  componentId: "sc-3v10ji-2"
})(["", " word-break:normal;text-decoration:none;font-size:14px;height:", ";display:flex;align-items:center;text-align:center;color:", ";transition:color ", ";transition-timing-function:", ";&:hover,&:focus{color:", ";}"], fontFamilyStyles, px2rem(80), function (props) {
  return props.$foregroundColor;
}, styles.transition.timing.slowest, styles.transition["function"].base, function (props) {
  return props.$hoverColor;
});

export { item, link, wrapper };
